import React, { useEffect, useState } from 'react'
import * as cookies from '../utilties/cookies'
import { injectIntl } from 'react-intl'
import { compose } from 'recompose'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { Grid } from '@material-ui/core'
import defaultBackground from '../assets/images/default-bg.png'
import defaultLogo from '../assets/images/logo_benchmarc.svg'
import { connect } from 'react-redux'
import { getTeamBackground, getTeamLogo } from '../redux/actions'
import { teamBackgroundIsLoadingSelector, teamBackgroundSelector, teamLogoIsLoadingSelector, teamLogoSelector } from '../redux/selectors'
import Header from './Header'

const useStyles = makeStyles((theme) => ({
    mainWrapper: {
        display: 'grid',
        backgroundColor: '#ededf1',
        minHeight: '100vh',
        paddingTop: '84px',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '61px',
            minHeight: 'unset'
        },
        position: 'relative',
		minWidth: '320px',
		overflowX: 'hidden',
		display: 'flex',
		[theme.breakpoints.up('lg')]: {
			minWidth: '1200px',
		},
    },
    mainHeaderWrapper: {
        height: '84px',
        backgroundColor: 'white',
        flexWrap: 'nowrap',
        borderBottom: '1px #171821 solid',
        [theme.breakpoints.down('sm')]: {
            height: '61px',
        },
    },
    mainContent: {
        position: 'relative',
        minHeight: 'calc(100vh - 84px)',
        [theme.breakpoints.down('sm')]: {
            minHeight: 'calc(100vh - 61px)',
            maxHeight: 'calc(100vh - 61px)',
        },
		maxHeight: 'calc(100vh - 84px)',
		overflowX: 'hidden',
		flexGrow: '100',
		minWidth: '320px',
		zIndex: '2',
		'WebkitOverflowScrolling': 'touch',
    },
    mainHeaderOuter: {
        height: '84px',
        borderBottom: '1px #9CA9BE solid',
        backgroundColor: 'white',
        padding: '0 32px',
        zIndex: '1000',
        flexWrap: 'nowrap',
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        width: '100%',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            height: '61px',
            backgroundColor: 'white',
            padding: '0 16px',
        },
    },
    mainHeaderInner: {
        height: '84px',
        maxWidth: '1400px',
        padding: '0 32px',
        zIndex: '1000',
        flexWrap: 'nowrap',
        position: 'fixed',
        top: '0',
        left: '0',
        right: '0',
        width: '100%',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            height: '61px',
            backgroundColor: 'white',
            padding: '0 16px',
            borderBottom: '1px #9CA9BE solid',
        },
    },
    mainHeaderBar: {
        padding: '0 32px',
        minHeight: '55px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#fff',
        width: '100%',
        maxWidth: '1400px',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            padding: '0 16px',
            height: 'auto',
            minHeight: 'unset'
        },   
        "@media (max-device-width: 959.95px)": {
            padding: '0 16px',
            height: 'auto',
            minHeight: 'unset'
        }
    },
    mainHeaderLogo: {
        padding: '10px 20px 10px 0',
        borderRight: '1px solid #EEF1F9',
        display: 'flex',
        maxWidth: '200px',
        height: '100%',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100px',
            paddingLeft: '20px'
        },
    },
    passportTitle: {
        fontSize: '24px',
        fontWeight: '600',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },
    mainBgImage: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        left: 0,
        width: '100%',
        height: '320px',
        backgroundColor: '#171821',
        [theme.breakpoints.down('sm')]: {
            height: '100px',
        },
        "&::before": {
            display: 'block',
            content: `''`,
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            background: 'rgba(0,0,0,0.4)',
        }
    }

}));
  

const LoginPagesWrapper = ({
    intl,
    children,
    logoUrl,
    backgroundUrl,
    teamBackground,
    loadTeamBackground,
    teamLogo,
    loadTeamLogo,
    teamLogoIsLoading,
    teamBackgroundIsLoading,
    hideMenu,
    hidePagesMenu,
    canChangeLanguage = true,
    ...other
}) => {
    const classes = useStyles();
    const [ patient ] = useState(cookies.get('user'))
    const [ teamLogoUrl, setTeamLogoUrl ] = useState(defaultLogo)


    useEffect(
        () => {
            if (
                !teamLogoIsLoading
                && !!logoUrl
            ) {
                setTeamLogoUrl(logoUrl)
            }
            else if (
                !teamLogoIsLoading
                && !!teamLogo
            ) {
                setTeamLogoUrl(teamLogo)
            }
            else {
                let v = defaultLogo
                setTeamLogoUrl(defaultLogo)
            }
        },
        [logoUrl, teamLogo, teamLogoIsLoading, defaultLogo]
    )

    useEffect(() => {
        if (!logoUrl) {
            loadTeamLogo()
        }

        if (!backgroundUrl) {
            loadTeamBackground()
        }
    }, [])

    return (
		<div data-testid="page-wrapper" className={`${classes.mainWrapper} mainPatientWrapper`}>

            <div data-testid="header" className={classes.mainHeaderWrapper} >
                <Header
                    data-testid="page-header"
                    hideMenu={hideMenu}
                    hidePagesMenu={hidePagesMenu}
                    isExternalAuth={patient && patient.externalAuth}
                    canChangeLanguage={canChangeLanguage}
                    canChangePassword={false}
                    disablePagesMenu={true}
                />
            </div>

            <div data-testid="main-content" className={classes.mainContent}>

                <div data-testid="main-content-bg-img" data-print="none"
                    className={classes.mainBgImage}
                    style={{
                        backgroundImage: `url(${( backgroundUrl || teamBackground || !teamBackgroundIsLoading && defaultBackground)})`
                    }}>
                </div>
                <div data-testid="main-content-inner"
                    style={{
                        position: 'relative',
                    }}>
                    {children}
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
	teamBackground: teamBackgroundSelector(state),
    teamBackgroundIsLoading: teamBackgroundIsLoadingSelector(state),
    teamLogo: teamLogoSelector(state),
    teamLogoIsLoading: teamLogoIsLoadingSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
	loadTeamBackground: () => dispatch(getTeamBackground()),
	loadTeamLogo: () => dispatch(getTeamLogo())
})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(LoginPagesWrapper)
